/* ============================================
   VINTAGE KNIFE SHOP — THEME JS
   ============================================ */

(function () {
  'use strict';

  // ==========================================
  // CSS Custom Properties: announcement + header heights
  // ==========================================
  function setHeightVars() {
    const bar = document.getElementById('announcement-bar');
    const header = document.getElementById('site-header');
    const barH = bar ? bar.offsetHeight : 0;
    const headerH = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-height', barH + 'px');
    document.documentElement.style.setProperty('--header-height', headerH + 'px');
  }

  // ==========================================
  // Header: transparent over hero, filled on scroll
  // ==========================================
  function initHeader() {
    const header = document.getElementById('site-header');
    if (!header) return;

    const isHomepage = document.body.classList.contains('template-index');
    if (!isHomepage) return;

    let ticking = false;

    function updateHeader() {
      const scrollY = window.scrollY;
      const threshold = window.innerHeight * 0.1;

      if (scrollY > threshold) {
        header.classList.remove('is-transparent');
        header.classList.add('is-filled');
      } else {
        header.classList.remove('is-filled');
        header.classList.add('is-transparent');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    updateHeader();
  }

  // ==========================================
  // Mobile nav toggle
  // ==========================================
  function initMobileNav() {
    const toggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.getElementById('mobile-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // ==========================================
  // Product image gallery (thumbnail switching)
  // ==========================================
  function initProductGallery() {
    const mainImage = document.getElementById('main-product-image');
    const thumbs = document.querySelectorAll('.product-thumb');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const fullSrc = thumb.getAttribute('data-full');
        if (fullSrc) {
          mainImage.src = fullSrc;
        }
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  // ==========================================
  // Init on DOM ready
  // ==========================================
  document.addEventListener('DOMContentLoaded', function () {
    setHeightVars();
    initHeader();
    initMobileNav();
    initProductGallery();
  });

  window.addEventListener('resize', function () {
    setHeightVars();
  }, { passive: true });

})();
